/**
 * Which entities an OSINT investigation can be launched on.
 *
 * The agent researches subjects that have a public footprint to research —
 * people and the bodies they act through. Running it on a phone number, a
 * conversation, a device or a bank account produces a brief with nothing to
 * search for, so the affordance is not offered there at all rather than
 * offered and then failing.
 *
 * Deliberately the same vocabulary as the register lookup's
 * REGISTER_LOOKUP_TYPES (see `components/neo4j/cytoscape/useCytoscapeContextMenu`):
 * an `Organization` is included because an analyst may well have typed a
 * registered body in as one.
 */
export const OSINT_INVESTIGABLE_TYPES: readonly string[] = ['Person', 'Company', 'Organization']

/**
 * Fails closed: a host that cannot tell what it is holding gets no button.
 * The type passed in is the label the surface itself shows for the entity, so
 * the gate always agrees with what the analyst is looking at.
 */
export function isOsintInvestigableType(type: string | null | undefined): boolean {
  return type != null && OSINT_INVESTIGABLE_TYPES.includes(type)
}
